import Button from "@mui/material/Button";
import React from "react";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export const DailyCalendarURI = "/calendar"
export const DailyCalendarButton = (props) => <Button {...props} variant={"contained"} size={"small"} startIcon={<CalendarTodayIcon size={"small"} />} href={DailyCalendarURI}><span style={{fontSize: "80%"}}>Daily Calendar</span></Button>